import { defineMessages } from 'react-intl';

const trns = defineMessages({
  searchCTA: {
    id: 'CyK0ag',
    defaultMessage: 'ШУКАТИ'
  },
  foundResultsTitle: {
    id: 'b+Y5Xd',
    defaultMessage: 'ЗНАЙДЕНІ ТОВАРИ'
  },
  searchHistoryTitle: {
    id: 'jajljv',
    defaultMessage: 'Історія пошуку'
  },
  categoriesTitle: {
    id: 'ALtAFZ',
    defaultMessage: 'КАТЕГОРІЇ'
  },
  viewAll: {
    id: '3KS51N',
    defaultMessage: 'Переглянути всі'
  },
  enterTitle: {
    id: '93OyqT',
    defaultMessage: 'Введіть найменування...'
  },
  enterTitleName: {
    id: '/BNdOR',
    defaultMessage: 'Введіть найменування товару'
  },
  loadMore: {
    id: 'eROQQF',
    defaultMessage: 'Всі результати пошуку'
  },
  warning: {
    id: 'y4MOZ6',
    defaultMessage:
      'Запит занадто короткий. Введіть більше 3 символів в поле пошуку та спробуйте знову.'
  },
  addDrugs: {
    id: 'kP/SI2',
    defaultMessage: 'Додайте інші товари з обраної аптеки'
  },
  foundTradenames: {
    id: 'XtE66v',
    defaultMessage: 'ТОРГОВІ НАЗВИ'
  }
});

export default trns;
